import { API_ERROR_OCCURRED } from '../mobileApp/actions/actions';

const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get('token');

const postData = (url = ``, data = {}, type = 'form') => {
  const esc = encodeURIComponent;
  const params = { ...data, token };
  const body =
    type === 'form'
      ? Object.keys(params)
          .map(k => esc(k) + '=' + esc(params[k]))
          .join('&')
      : JSON.stringify(data);

  // Default options are marked with *
  return fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, cors, *same-origin
    cache: 'no-store', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, same-origin, *omit
    headers: {
      'Content-Type':
        type === 'form'
          ? 'application/x-www-form-urlencoded'
          : 'application/json; charset=utf-8'
    },
    redirect: 'follow', // manual, *follow, error
    referrer: 'no-referrer', // no-referrer, *client
    body // body data type must match "Content-Type" header
  })
    .then(response => response.json()) // parses response to JSON
    .then(response => {
      if (Number(response.status_code) !== 0) {
        throw Error(response.message);
      } else {
        return response.data || response.results;
      }
    })
    .catch(e => {
      throw Error(getErrorMessage(e));
    });
};

let baseUrl;
const host = window.location.host;
if (host.indexOf('localhost') !== -1) {
  baseUrl = 'http://localhost:81';
} else if (host.indexOf('dev.tutorsync.com') !== -1) {
  baseUrl = 'http://dev.tutorsync.com:81';
} else if (host.indexOf('tutorsync.com') !== -1) {
  baseUrl = 'https://api.tutorsync.com/tutor-sync-api/api/public';
}

export function request(endPoint, data, dispatch) {
  return postData(`${baseUrl}/${endPoint}`, data).catch(error => {
    const message =
      typeof error === 'string' ? error.message : getErrorMessage(error);
    dispatch({
      type: API_ERROR_OCCURRED,
      message,
      refresh: true
    });
  });
}

export const COMMON_ERROR_MESSAGE =
  'If this keep happening, please let TutorSync know.';

export const getErrorMessage = error => {
  if (typeof error.message !== 'string' || error.message === '') {
    return `Sorry, unknown error occurred. Please try again. ${COMMON_ERROR_MESSAGE}`;
  }

  if (error.message === 'Failed to fetch') {
    return `Please check your internet connection and try again. ${COMMON_ERROR_MESSAGE}`;
  }

  return error.message;
};

export function apiRequest(endPoint, data, type = 'json') {
  return postData(`${baseUrl}/${endPoint}`, data, type);
}
